const modalReqApp = {
  namespaced: true,
  state: () => ({
    modalExtendSap: false,
    modalBlockVendor: false,
    modalUnblockVendor: false,

    modalViewExtend: false,
    modalViewBlock: false,
    modalViewUnblock: false,

    modalReview: false,
    modalResendEmailK3l: false,
    modalResendEmailKplh: false,
    modalDeleteVendor: false,

    modalPraqualifikasi: false,
    modalPraqualifikasiLevel2: false,
  }),
  mutations: {
    SET_VALUE(state, data) {
      state[data.name] = data.value
    },
    CLOSE_ALL(state, data) {
      state.modalExtendSap = false
      state.modalBlockVendor = false
      state.modalUnblockVendor = false
      state.modalViewExtend = false
      state.modalViewBlock = false
      state.modalViewUnblock = false
      state.modalReview = false
      state.modalResendEmailK3l = false
      state.modalPraqualifikasi = false
    },
  },
  actions: {},
}

export default modalReqApp
